import { Model } from '@vuex-orm/core'
import requestSerializer from 'aveine-toolbox/src/store/adapter/serializer'
import WineOfTheMonth from './wine-of-the-month'

/**
 * Une etiquette libre de la carte « Vin du mois » (REDMINE-12962) :
 * « 6h d'aeration », « Grande occasion ».
 *
 * Saisies et non derivees du vin : « Grande occasion » n'existe nulle part dans
 * le modele, et l'editorial doit pouvoir afficher une duree d'aeration
 * differente de la valeur calculee s'il le juge utile.
 */
export default class WineOfTheMonthTag extends Model {
  static entity = 'wine_of_the_month_tags'

  static fields () {
    return {
      '$entity_name': this.attr(this.entity),
      'id': this.attr(null),
      'label': this.attr({}),
      'position': this.number(null).nullable(),
      'wine_of_the_month': this.belongsTo(WineOfTheMonth, 'wine_of_the_month_id'),
      'wine_of_the_month_id': this.attr(null),
      'created_at': this.string(),
      'updated_at': this.string(),
      'deleted': this.boolean(false)
    }
  }

  static readOnlyFields = ['wine_of_the_month_id']

  static apiConfig = {
    transformRequest: (data) => {
      if (data) {
        return requestSerializer(this.entity, data)
      } else {
        return null
      }
    }
  }
}
